<div
    *ngIf="{
        lastSection: lastSection$ | async,
        cartItems: cartItem$ | async,
        isOpenForSale: isOpenForSale$ | async,
        isCategoryPage: isCategoryPage$ | async,
        latestHomeSeoUrl: latestHomeSeoUrl$ | async,
        username: username$ | async,
        resolution: resolution$ | async,
        isHomePage: isHomePage$ | async,
        isLogged: isAuthenticated$ | async
    } as headerData"
    class="header-topbar"
    [ngClass]="{
        'is-rtl': direction === 'rtl',
        'transparent-header': headerData.isCategoryPage
    }"
    #container
>
    <div class="container-total">
        <div class="row header-desktop">
            <div class="col-xs-2 col-sm-5 col-md-4 text-left is-flex content-start header-start">
                @if ((isOpenMenu$ | async) === false) {
                    <button aria-label="Open menú" class="btn-link btn-link-menu cursor-pointer header-menu-icon" (click)="openMenu()">
                        <md-icon name="menu-ham"></md-icon>
                    </button>
                } @else {
                    <!-- Autofocus it's required when open menu, it's a modal (This Close shouldn't be here) -->
                    <!-- eslint-disable @angular-eslint/template/no-autofocus -->
                    <button
                        aria-label="Close menú"
                        class="btn-link btn-link-menu cursor-pointer header-menu-icon"
                        (click)="closeMenu()"
                        tabindex="0"
                        autofocus
                    >
                        <md-icon name="close"></md-icon>
                    </button>
                }

                @if (!!categories) {
                    <header-sections
                        [categories]="categories"
                        [section]="(section$ | async).section"
                        [isSearchPage]="isSearchPage$ | async"
                        [isNavigateHomeEnabled]="true"
                        [isCenterHeader]="true"
                    ></header-sections>
                }
            </div>
            <div
                class="col-xs-4 col-sm-2 col-md-4 sm:hidden text-center is-flex h-auto content-center align-items-center cursor-pointer header-search header-center"
            >
                @if ((isSearchPage$ | async) === false) {
                    <header-search></header-search>
                }
            </div>
            <div class="col-xs-10 col-sm-5 col-md-4 text-center header-end">
                <ul class="list-clear text-right is-flex content-end align-items-center h-100">
                    @defer {
                        @if (isLogged === false && headerData.isOpenForSale) {
                            <li class="sm:hidden pr-20">
                                <button
                                    [attr.aria-label]="'header_login' | translate"
                                    class="btn-link topbar-link cursor-pointer text-l"
                                    (click)="openLogin()"
                                >
                                    {{ 'header_login' | translate }}
                                </button>
                            </li>
                        } @else if (isLogged && headerData.isOpenForSale) {
                            <li class="sm:hidden pr-20">
                                <button
                                    [attr.aria-label]="'header_my_account' | translate"
                                    class="btn-link topbar-link ttu cursor-pointer text-l"
                                    (click)="openMyAccount()"
                                >
                                    {{ headerData.username || ('header_my_account' | translate) }}
                                </button>
                            </li>
                        }
                    }

                    <li class="sm:visible">
                        <button [attr.aria-label]="'header_search' | translate" class="btn-link topbar-link text-l" (click)="openSearch()">
                            {{ 'header_search' | translate }}
                        </button>
                    </li>

                    @if (headerData.isOpenForSale) {
                        <li class="pl-20">
                            <button
                                [attr.aria-label]="'header_shop_cart' | translate"
                                class="btn-link text-l topbar-link"
                                (click)="openShopCart($event)"
                                elementObserverDirective
                                [observeType]="'analyticsClick'"
                                [observedData]="{ clickId: ANALYTICS_CLICK_SOURCE_ID_VIEW_MINICART }"
                            >
                                <span>
                                    {{ 'header_shop_cart' | translate }}
                                    @if (headerData.cartItems > 0) {
                                        <span class="cart-items topbar-link">({{ headerData.cartItems }})</span>
                                    }
                                </span>
                            </button>
                        </li>
                    }
                </ul>
            </div>
        </div>
        <div class="header-mobile">
            <app-header-topbar-sm-2024
                [icon]="'bars'"
                [hiddenLogo]="headerData.isHomePage"
                [cartItems]="headerData.cartItems"
                [isOpenForSale]="headerData.isOpenForSale"
                [lastSection]="headerData.lastSection"
                [latestHomeSeoUrl]="headerData.latestHomeSeoUrl"
                [isLogged]="headerData.isLogged"
            ></app-header-topbar-sm-2024>
        </div>
    </div>
</div>
<div class="header-gradient">
    <div class="header-gradient-start"></div>
    <div class="header-gradient-center"></div>
    <div class="header-gradient-end"></div>
</div>
